import React from 'react';
import { FlameIcon, ZapIcon, BrainIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-neutral-950 text-white py-20 md:py-28 px-4 relative overflow-hidden" data-id="element-179">
      {/* Background glow */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-amber-500/5 blur-[150px] pointer-events-none" data-id="element-180"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-amber-500 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-183">
            Introducing
          </h2>
          <h3 className="text-4xl md:text-6xl font-extrabold mb-6" data-id="element-184">
            The 40+ Vitality Code
          </h3>
          <p className="text-2xl md:text-3xl text-gray-300 font-light mb-8" data-id="element-185">
            The 21-Day Bio-Hormonal Reset for High-Performance Men.
          </p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto bg-gray-900/50 p-4 rounded-lg border border-gray-800" data-id="element-186">
            This isn't a 2-hour gym routine. This is a{' '}
            <strong className="text-white" data-id="element-187">15-minute daily protocol</strong>{' '}
            designed to:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-188">
          {/* Card 1 */}
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 hover:border-amber-500/30 transition-colors duration-300 relative group" data-id="element-189">
            <div className="absolute inset-0 bg-gradient-to-b from-red-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl" data-id="element-190"></div>
            <div className="w-14 h-14 bg-red-500/10 rounded-xl flex items-center justify-center mb-6 border border-red-500/20" data-id="element-191">
              <FlameIcon className="w-7 h-7 text-red-500" data-id="element-192" />
            </div>
            <h4 className="text-2xl font-bold mb-4 text-white" data-id="element-193">
              Flush Cortisol
            </h4>
            <p className="text-gray-400 leading-relaxed" data-id="element-194">
              Kill the stress hormone that creates the stubborn "Dad Bod" and
              low-level anxiety. Reset your nervous system for calm, grounded
              leadership.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 hover:border-amber-500/30 transition-colors duration-300 relative group" data-id="element-195">
            <div className="absolute inset-0 bg-gradient-to-b from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl" data-id="element-196"></div>
            <div className="w-14 h-14 bg-amber-500/10 rounded-xl flex items-center justify-center mb-6 border border-amber-500/20" data-id="element-197">
              <ZapIcon className="w-7 h-7 text-amber-500" data-id="element-198" />
            </div>
            <h4 className="text-2xl font-bold mb-4 text-white" data-id="element-199">
              Ignite Natural T-Levels
            </h4>
            <p className="text-gray-400 leading-relaxed" data-id="element-200">
              Using 2026 bio-optimization secrets that work in days, not months.
              Wake up with the physical drive and energy you had in your 20s.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 hover:border-amber-500/30 transition-colors duration-300 relative group" data-id="element-201">
            <div className="absolute inset-0 bg-gradient-to-b from-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl" data-id="element-202"></div>
            <div className="w-14 h-14 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6 border border-emerald-500/20" data-id="element-203">
              <BrainIcon className="w-7 h-7 text-emerald-500" data-id="element-204" />
            </div>
            <h4 className="text-2xl font-bold mb-4 text-white" data-id="element-205">
              Restore Elite Focus
            </h4>
            <p className="text-gray-400 leading-relaxed" data-id="element-206">
              Reclaim the "Mental Clarity" that took you to the top. Eliminate
              brain fog and experience razor-sharp concentration during your
              most important work.
            </p>
          </div>
        </div>
      </div>
    </section>;
}